"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PollTeacherActions = exports.PollStatus = void 0;
var PollStatus = {
  DRAFT: 'DRAFT',
  LIVE: 'LIVE',
  COMPLETE: 'COMPLETE'
};
exports.PollStatus = PollStatus;
var PollTeacherActions = {
  ADD_NEW_POLL: 'ADD_NEW_POLL',
  QUESTION_TEXT_CHANGE: 'QUESTION_TEXT_CHANGE',
  OPTION_TEXT_CHANGE: 'OPTION_TEXT_CHANGE',
  OPTION_IMAGE_CHANGE: 'OPTION_IMAGE_CHANGE',
  OPTION_IMAGE_REMOVE: 'OPTION_IMAGE_REMOVE',
  ADD_NEW_OPTION: 'ADD_NEW_OPTION',
  DELETE_OPTION: 'DELETE_OPTION',
  DELETE_POLL_CONFIRMATION: 'DELETE_POLL_CONFIRMATION',
  POLL_SELECTED: 'POLL_SELECTED',
  CLOSE_POLL_MENU: 'CLOSE_POLL_MENU',
  SAVE_POLL: 'SAVE_POLL',
  MAKE_POLL_LIVE: 'MAKE_POLL_LIVE',
  SET_SHOW_LEARNERS: 'SET_SHOW_LEARNERS',
  END_POLL: 'END_POLL',
  SHARE_RESULTS: 'SHARE_RESULTS',
  DELETE_POLL: 'DELETE_POLL'
};
exports.PollTeacherActions = PollTeacherActions;